import { ALTS_COLORS } from "@/utils/colors";
import { useIsMobile } from "@/hooks/use-mobile";

interface CustomLegendProps {
  allData: { name: string; value: number }[];
  hiddenSectors: string[];
  onLegendClick: (entry: { value: string }) => void;
}

export const CustomLegend = ({ allData, hiddenSectors, onLegendClick }: CustomLegendProps) => {
  const colors = [
    ALTS_COLORS.spaceCadet,
    ALTS_COLORS.yaleBlue,
    ALTS_COLORS.yinMnBlue,
    ALTS_COLORS.paynesGray,
    ALTS_COLORS.battleshipGray,
    ALTS_COLORS.lion,
    ALTS_COLORS.satinSheenGold,
    ALTS_COLORS.goldenrod
  ];

  const isMobile = useIsMobile();

  return (
    <div className={`grid ${isMobile ? 'grid-cols-2' : 'grid-cols-4'} gap-2 w-full px-2`}>
      {allData.map((entry, index) => {
        const isHidden = hiddenSectors.includes(entry.name);
        const hasZeroAllocation = entry.value === 0;
        
        return (
          <div
            key={`legend-${index}`}
            className="flex items-center gap-2 cursor-pointer"
            onClick={() => onLegendClick({ value: entry.name })}
          >
            <div
              className={`w-3 h-3 rounded-sm flex-shrink-0 ${
                isHidden || hasZeroAllocation ? "opacity-50" : ""
              }`}
              style={{ backgroundColor: colors[index] }}
            />
            <span className={`text-sm truncate ${
              isHidden || hasZeroAllocation ? "text-gray-400" : "text-gray-700"
            }`}>
              {entry.name}
            </span>
          </div>
        );
      })}
    </div>
  );
};